import dayjs from 'dayjs'
import Tooltip from '../../common/Tooltip'
import { capitalizeFirstLetter } from '../../../lib/utils'
import { DATE_FORMAT, LAB_ORDER_STATUS } from '../../../lib/const'
import { useLabOrderDetailsStore } from '../../../stores'
import EditModal from '../../common/Modals/EditModal'

import { ReactComponent as DownloadAlternativeIcon } from '../../../images/icons/dowload-alternative.svg'
import { ReactComponent as TrackingIcon } from '../../../images/icons/tracking.svg'
import { ReactComponent as ZipIcon } from '../../../images/icons/zip.svg'
import { ReactComponent as NoteIcon } from '../../../images/icons/note.svg'
import { ReactComponent as EditIcon } from '../../../images/icons/edit-alternative.svg'

const Header = ({ attributes }) => {
  const { createZip, createZipFile, downloadLink, isAdmin, progressPercent, isTrackingModalOpen, setIsTrackingModalOpen, trackingUrl, setTrackingUrl, trackingLoading, updateTrackingUrl } = useLabOrderDetailsStore()
  // const vendorId = Number(attributes?.vendorId)
  let orderNumber = attributes?.orderNumber
  const orderDate = attributes.status === 'open' ? attributes.createdAt : attributes.paidAt

  // if (vendorId === 1) orderNumber = attributes?.orderName
  // if (vendorId === 2) orderNumber = attributes?.externalOrderId

  let zipButtonLabel = 'Create ZIP File'
  if (createZip) zipButtonLabel = 'Creating ZIP File...'
  if (!createZip && downloadLink) zipButtonLabel = 'Create Again'

  const handleCreateZipFile = async (event) => {
    event.preventDefault()
    await createZipFile(attributes?.guid)
  }

  const handleUpdateTrackingUrl = async () => {
    await updateTrackingUrl(attributes?.guid, trackingUrl)
  }

  return (
    <div className="order-top-div lab-order-header">
      <div className="w-layout-grid grid-button-topbar-orders lab-order-header-actions">
        {attributes?.status !== 'open' && isAdmin && (
          <>
            {downloadLink && (
              <a href={downloadLink} className="_2nd-button main w-inline-block">
                <div className="icon right-margin w-embed">
                  <DownloadAlternativeIcon />
                </div>
                <div>Download Order</div>
              </a>
            )}
            <button
              type="button"
              className="_2nd-button main w-inline-block"
              onClick={handleCreateZipFile}
              disabled={createZip}
            >
              <div className="icon right-margin w-embed">
                <ZipIcon />
              </div>
              <div>{zipButtonLabel}</div>
            </button>
          </>
        )}
      </div>

      <div className="lab-order-header-summary">
        <div className="lab-order-header-title">
          <span className="heading-gray">Order #</span>
          <span className="heading-big">{orderNumber || '-'}</span>
        </div>
        <div className="lab-order-header-status">
          <span className={`status-order ${attributes?.status}`}>
            {capitalizeFirstLetter(LAB_ORDER_STATUS[attributes.status].label)}
          </span>
          {attributes?.hasNotes && (
            <Tooltip title="Order Note">
              <span className="note tippy">
                <span className="icon small w-embed">
                  <NoteIcon />
                </span>
              </span>
            </Tooltip>
          )}
        </div>
        <div className="w-layout-grid grid-29 lab-order-header-progress">
          <div className="div-block-113">In Progress</div>
          <div data-tippy-content="Progress" className="w-layout-grid grid-progress-bar _2">
            <div className="progress-bar">
              <div className="bar" style={{ '--progress-width': `${progressPercent}%` }} />
            </div>
            <div>{`${progressPercent}%`}</div>
          </div>
        </div>
      </div>

      <div className="grid-details right lab-order-date-details">
        <h3 className="heading-mini-gray">
          {attributes?.status === 'open' ? 'Order created on:' : 'Placed on:'}
        </h3>
        <h3 className="heading-title-2">{orderDate ? dayjs(orderDate).format(DATE_FORMAT.full) : '-'}</h3>
        <div className="grid-tracking lab-order-header-tracking">
          {/* Tracking Number display retained for possible future use.
          <div className="div-block-135">
            <div className="icon small right-margin w-embed">
              <TrackingIcon />
            </div>
            <div>Tracking Number</div>
          </div>
          <div className="tracking-text">{attributes?.trackingNumber || '-'}</div>
          */}
          {isAdmin && (
            <button
              type="button"
              className="upgrade-button w-inline-block"
              onClick={() => setIsTrackingModalOpen(!isTrackingModalOpen)}
            >
              <div className="icon small right-margin w-embed">
                <TrackingIcon />
              </div>
              <div className="text-block-30">
                {attributes?.trackingUrl ? 'Edit Tracking URL' : 'Add Tracking URL'}
              </div>
            </button>
          )}
          {attributes?.trackingUrl && (
            <a
              href={attributes.trackingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="upgrade-button w-inline-block"
            >
              <div className="text-block-30">Track Order</div>
            </a>
          )}
        </div>
        {isAdmin && (
          <EditModal
            loading={trackingLoading}
            isOpen={isTrackingModalOpen}
            onClose={() => setIsTrackingModalOpen(false)}
            title="Add / Edit Tracking"
            icon={EditIcon}
            fields={[
              {
                placeholder: 'US 460 220 560 320 480',
                value: trackingUrl,
                onChange: setTrackingUrl,
                required: true,
              },
            ]}
            onSave={handleUpdateTrackingUrl}
          />
        )}
      </div>
    </div>
  )
}

export default Header
